import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrUser } from '@/store/bootstrap/selectors';

/**
 * Hook to check if requisitions feature is enabled for the current user.
 * Driven by the user-level permission (requisition.enabled).
 *
 * @returns Object containing:
 * - isEnabled: boolean indicating if requisitions are enabled
 * - requisitionEnabled: user-level permission value
 */
export const useRequisitionsEnabled = () => {
  const currUser = useSelector(selectCurrUser);

  return useMemo(() => {
    const requisitionEnabled = Boolean(currUser?.requisition?.enabled);

    return {
      isEnabled: requisitionEnabled,
      requisitionEnabled,
    };
  }, [currUser?.requisition?.enabled]);
};
